export default __webpack_public_path__ + "static/media/EngineeringSkyscrapers_01.6c738d26.png";